import Parallax from 'parallax-js';

if (document.querySelector('[data-parallax-el]') && window.innerWidth >= 1025) {
  const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
  parallaxContainer.forEach((elem) => {
    let parallaxInstance = new Parallax(elem);
    parallaxInstance.enable();
  });
}


// Worldwide sec lines

(function () {
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const DEFAULT_DRAW_OPTIONS = {
    delay: 0,
    speed: 1400,
    easing: 'linear',
    threshold: 0.35,
    once: true,
    path: 'path',
  };
  let drawMaskUid = 0;

  const toNumber = function (value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const toBoolean = function (value, fallback) {
    if (value === undefined) {
      return fallback;
    }
    if (value === 'true' || value === '1') {
      return true;
    }
    if (value === 'false' || value === '0') {
      return false;
    }
    return fallback;
  };

  const clamp01 = function (value) {
    return Math.max(0, Math.min(1, value));
  };

  const getPaths = function (line, selector) {
    const paths = Array.from(line.querySelectorAll(selector));
    if (paths.length) {
      return paths;
    }
    if (line.tagName && line.tagName.toLowerCase() === 'path') {
      return [line];
    }
    return [];
  };

  const getSvgBounds = function (svg) {
    const viewBox = svg.getAttribute('viewBox');
    if (viewBox) {
      const parts = viewBox.trim().split(/\s+/).map(Number);
      if (parts.length === 4 && parts.every(Number.isFinite)) {
        return {
          x: parts[0],
          y: parts[1],
          width: Math.max(1, parts[2]),
          height: Math.max(1, parts[3]),
        };
      }
    }

    const vb = svg.viewBox && svg.viewBox.baseVal;
    if (vb && vb.width && vb.height) {
      return {
        x: vb.x,
        y: vb.y,
        width: Math.max(1, vb.width),
        height: Math.max(1, vb.height),
      };
    }

    const rect = svg.getBoundingClientRect();
    return {
      x: 0,
      y: 0,
      width: Math.max(1, rect.width),
      height: Math.max(1, rect.height),
    };
  };

  const preparePathMask = function (path) {
    const svg = path.ownerSVGElement;
    if (!svg) {
      return null;
    }

    const length = Math.ceil(path.getTotalLength());
    let defs = svg.querySelector('defs');
    if (!defs) {
      defs = document.createElementNS(SVG_NS, 'defs');
      svg.insertBefore(defs, svg.firstChild);
    }

    drawMaskUid += 1;
    const maskId = 'draw-line-mask-' + drawMaskUid;
    const maskPathId = 'draw-line-mask-path-' + drawMaskUid;

    const bounds = getSvgBounds(svg);
    const mask = document.createElementNS(SVG_NS, 'mask');
    mask.setAttribute('id', maskId);
    mask.setAttribute('maskUnits', 'userSpaceOnUse');
    mask.setAttribute('maskContentUnits', 'userSpaceOnUse');
    mask.setAttribute('x', String(bounds.x));
    mask.setAttribute('y', String(bounds.y));
    mask.setAttribute('width', String(bounds.width));
    mask.setAttribute('height', String(bounds.height));

    const maskBg = document.createElementNS(SVG_NS, 'rect');
    maskBg.setAttribute('x', String(bounds.x));
    maskBg.setAttribute('y', String(bounds.y));
    maskBg.setAttribute('width', String(bounds.width));
    maskBg.setAttribute('height', String(bounds.height));
    maskBg.setAttribute('fill', '#000');

    const maskPath = document.createElementNS(SVG_NS, 'path');
    maskPath.setAttribute('id', maskPathId);
    maskPath.setAttribute('d', path.getAttribute('d') || '');
    maskPath.setAttribute('fill', 'none');
    maskPath.setAttribute('stroke', '#fff');
    maskPath.setAttribute('stroke-width', path.getAttribute('stroke-width') || '2');
    maskPath.setAttribute('stroke-linecap', path.getAttribute('stroke-linecap') || 'round');
    maskPath.setAttribute('stroke-linejoin', path.getAttribute('stroke-linejoin') || 'round');

    const transform = path.getAttribute('transform');
    if (transform) {
      maskPath.setAttribute('transform', transform);
    }

    mask.appendChild(maskBg);
    mask.appendChild(maskPath);
    defs.appendChild(mask);

    path.setAttribute('mask', 'url(#' + maskId + ')');
    path.style.opacity = '0';

    const dashPattern = String(length) + ' ' + String(length);
    maskPath.style.strokeDasharray = dashPattern;
    maskPath.style.strokeDashoffset = String(length);

    return {
      length: length,
      path: path,
      drawPath: maskPath,
    };
  };

  const initDrawLines = function () {
    const lines = Array.from(document.querySelectorAll('[data-draw-line]'));
    if (!lines.length) {
      return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    lines.forEach(function (line, index) {
      const options = {
        delay: Math.max(0, toNumber(line.dataset.drawDelay, DEFAULT_DRAW_OPTIONS.delay)),
        speed: Math.max(50, toNumber(line.dataset.drawSpeed, DEFAULT_DRAW_OPTIONS.speed)),
        easing: line.dataset.drawEasing || DEFAULT_DRAW_OPTIONS.easing,
        threshold: clamp01(toNumber(line.dataset.drawThreshold, DEFAULT_DRAW_OPTIONS.threshold)),
        once: toBoolean(line.dataset.drawOnce, DEFAULT_DRAW_OPTIONS.once),
        pathSelector: line.dataset.drawPath || DEFAULT_DRAW_OPTIONS.path,
      };

      if (line.dataset.drawDelay === undefined && index > 0) {
        options.delay = DEFAULT_DRAW_OPTIONS.delay;
      }

      const paths = getPaths(line, options.pathSelector);
      if (!paths.length) {
        return;
      }

      const drawItems = paths
        .map(function (path) {
          return preparePathMask(path);
        })
        .filter(Boolean);

      if (!drawItems.length) {
        return;
      }

      const state = {
        line: line,
        options: options,
        drawItems: drawItems,
        hasPlayed: false,
        timers: [],
      };

      const clearTimers = function () {
        state.timers.forEach(function (timerId) {
          window.clearTimeout(timerId);
        });
        state.timers = [];
      };

      const reset = function () {
        clearTimers();
        state.drawItems.forEach(function (item) {
          item.path.style.opacity = '0';
          item.drawPath.style.transition = 'none';
          item.drawPath.style.strokeDasharray = String(item.length) + ' ' + String(item.length);
          item.drawPath.style.strokeDashoffset = String(item.length);
        });
      };

      const showInstantly = function () {
        clearTimers();
        state.drawItems.forEach(function (item) {
          item.path.style.opacity = '1';
          item.drawPath.style.transition = 'none';
          item.drawPath.style.strokeDashoffset = '0';
        });
      };

      const animate = function () {
        clearTimers();
        const timerId = window.setTimeout(function () {
          state.drawItems.forEach(function (item) {
            item.path.style.opacity = '1';
            item.drawPath.style.transition = 'stroke-dashoffset ' + state.options.speed + 'ms ' + state.options.easing;
            item.drawPath.style.strokeDashoffset = '0';
          });
        }, state.options.delay);
        state.timers.push(timerId);
      };

      reset();

      if (prefersReducedMotion) {
        showInstantly();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        animate();
        state.hasPlayed = true;
        return;
      }

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!state.hasPlayed || !state.options.once) {
                animate();
                state.hasPlayed = true;
              }
              if (state.options.once) {
                observer.unobserve(state.line);
              }
            } else if (!state.options.once && state.hasPlayed) {
              reset();
            }
          });
        },
        { threshold: state.options.threshold }
      );

      observer.observe(state.line);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawLines, { once: true });
  } else {
    initDrawLines();
  }
})();
